import { IconKeyboardArrowDown } from "../icon/variants/IconKeyboardArrowDown.js";
import { Box, Collapse, Flex } from "../mantine-passthroughs/index.js";
import { BareCard } from "../card/BareCard.js";
import { ElevatedCard } from "../card/ElevatedCard.js";
import { FilledCard } from "../card/FilledCard.js";
import { OutlinedCard } from "../card/OutlinedCard.js";
import { useDisclosure } from "../../hooks/mantine-passthroughs/index.js";
import collapsible_card_module_default from "./collapsible-card.module.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/collapsible-card/CollapsibleCard.tsx
const variants = {
	bare: BareCard,
	elevated: ElevatedCard,
	filled: FilledCard,
	outlined: OutlinedCard,
	highlighted: FilledCard
};
const CollapsibleCard = ({ children, defaultOpen = false, header, footer, variant, fullWidthFooter = false, ...restProps }) => {
	const [isOpen, { toggle }] = useDisclosure(defaultOpen);
	const Card = variants[variant];
	const CardHeader = /* @__PURE__ */ jsxs(Flex, {
		component: "a",
		onClick: toggle,
		justify: "space-between",
		align: "center",
		style: {
			cursor: "pointer",
			width: "100%"
		},
		"data-testid": "collapsible-card-expand",
		children: [/* @__PURE__ */ jsx(Box, {
			style: { flex: 1 },
			children: header
		}), /* @__PURE__ */ jsx(Box, {
			style: { alignSelf: "start" },
			children: /* @__PURE__ */ jsx(IconKeyboardArrowDown, { style: {
				transition: "transform 200ms ease",
				transform: isOpen ? "rotate(180deg)" : ""
			} })
		})]
	});
	return /* @__PURE__ */ jsx(Card, {
		...restProps,
		header: CardHeader,
		footer,
		fullWidthFooter,
		children: /* @__PURE__ */ jsx(Collapse, {
			"data-state": isOpen ? "open" : "closed",
			className: collapsible_card_module_default.collapse,
			expanded: isOpen,
			children
		})
	});
};

//#endregion
export { CollapsibleCard };